import { toast } from "react-toastify";
import { apiUrl } from "../../Constants/Constants";

/**
 * تابع سازنده لاجیک خرید ترافیک
 */
export const createBuyTrafficLogic = (
  { fetchWithToken, getInfo, onLogout, account, closeFinalModal },
  modalContext
) => {
  const {
    openUpModal,
    description,
    confirmTitle,
    payloadConfirm,
    toDo,
    closeModal,
  } = modalContext;

  /**
   * مرحله اول: نمایش modal تأیید
   */
  const payTrafficRenewPay = (selectedTraffic, amount) => {
    confirmTitle("تایید پرداخت؟");
    openUpModal();

    description(
      <>
        با تایید شما، مبلغ
        <strong style={{ padding: "5px", display: "inline-block" }}>
          {amount.toLocaleString("fa-IR")} تومان
        </strong>
        از کیف پول شما کسر خواهد شد.
      </>
    );

    toDo(() => payWithWalletOnTraffic);
    payloadConfirm(selectedTraffic);
  };

  /**
   * مرحله دوم: پس از تأیید پرداخت
   */
  const payWithWalletOnTraffic = (gigpack) => {
    const former = new FormData();
    former.append("selectedtraffic", gigpack);
    former.append("accountid", account);

    fetchWithToken(
      apiUrl + "user/pay-traffic-wallet",
      { method: "POST" },
      former
    ).then((data) => {
      if (data.status === "200") {
        toast.success("با موفقیت پرداخت گردید.");
        closeFinalModal("trafficBuy");
        closeModal();
        getInfo();
      } else if (data.status === "6") {
        toast.error(data.data);
      }
      if (data.status === "401") {
        onLogout();
      }
    });
  };

  const paybatchTrafficPay = (selectedTraffic, accountid) => {
    const former = new FormData();
    former.append("selectedtraffic", selectedTraffic);
    former.append("accountid", accountid);

    fetchWithToken(
      apiUrl + "user/traffic-pay",
      {
        method: "POST",
      },
      former
    ).then((data) => {
      if (data.status === "200") {
        toast.info("در حال انتقال به دروازه پرداخت...");
        window.location.replace(data.data);

        closeModal("trafficBuy");
        closeModal("confirm");

        getInfo();
      } else if (data.status === "6") {
        toast.error(data.data);
      }
      if (data.status === "401") {
        onLogout();
      }
    });
  };

  return {
    payTrafficRenewPay,
    payWithWalletOnTraffic,
    paybatchTrafficPay,
  };
};
